import 'owl';
import 'lightgallery';

class PassportSlider {
    constructor() {
        let _this = this;

        this.owl = $('.shop-passport-gallery__owl').owlCarousel({
            items: 1,
            dots: true,
            responsiveRefreshRate: 10,
            lazyLoad: true,
            nav: false,
            mouseDrag: _this.drag(),
            touchDrag: _this.drag(),
        });

        this.lg = $('.light-gallery').lightGallery({
            thumbnail: true,
            download: false,
            counter: false,
            showThumbByDefault: false,
        });

        $('.shop-passport-gallery__sm-block').on('click', function () {
            if ($(this).hasClass('disabled')) return;
            let index = $(this).index();
            _this.owl.trigger('to.owl.carousel', [index, 0]);
            $(this)
                .addClass('active')
                .siblings('.shop-passport-gallery__sm-block')
                .removeClass('active');
        });

        $('.js-passport-gallery-more').on('click', function () {
            let index = $('.shop-passport-gallery__sm-block.active').index();
            let lgSlide = $('.light-gallery').children('a').eq(index);
            lgSlide.trigger('click');
        });

        $(document).on(
            'click',
            '.shop-passport-gallery__zoom-area',
            function () {
                let index = $(
                    '.shop-passport-gallery__sm-block.active'
                ).index();
                let lgSlide = $('.light-gallery').children('a').eq(index);
                lgSlide.trigger('click');
            }
        );
    }

    drag() {
        if ($(window).innerWidth() >= 720) {
            return false;
        }
        return true;
    }
}

export default new PassportSlider();
